var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputPerson = function SvgInputPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .692c-2.11 0-3.819 1.724-3.819 3.85S6.891 8.392 9 8.392s3.819-1.724 3.819-3.85-1.71-3.85-3.82-3.85M6.588 9.608c-2.11 0-3.819 1.724-3.819 3.85s1.71 3.85 3.819 3.85h4.824c2.109 0 3.819-1.724 3.819-3.85s-1.71-3.85-3.82-3.85z"
  })));
};
export { SvgInputPerson as ReactComponent };